import classes from "./HeaderCartButton.module.css";


// cart button on page header
const HeaderCartButton = (props) => {
  const imageString = process.env.REACT_APP_ASSETS_URL + "/assets/icons/book_icon_thick.svg"
  return (
    <img
      src={imageString}
      alt="new"
      className={classes.button}
      onClick={props.showCart}
    />
  );
};

export default HeaderCartButton;
